import React, { FC, useContext } from 'react';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';

import { ClubRules, ShellLanguage } from './components';

export const LanguageClubRules: FC = () => {
  const { t } = useContext(LocalizationContext);

  return (
    <>
      <SettingsBlock title={t('settings.shell.lang.title')}>
        <ClubRules />
        <SettingsFrame>
          <ShellLanguage />
        </SettingsFrame>
      </SettingsBlock>
    </>
  );
};
